import React from "react";
import { Outlet } from "react-router";

export default function AdminLayout() {
  return (
    <article>
      <Outlet />
    </article>
  );
}
